/*
 * Copyright © 2016-2020 The Thingsboard Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
import './silo-overview.scss';

/* eslint-disable import/no-unresolved, import/default */

import siloOverviewTemplate from './silo-overview.tpl.html';

/* eslint-enable import/no-unresolved, import/default */

export default angular.module('agrolog.client.siloOverview', [])
    .directive('agSiloOverview', SiloOverview)
    .name;

/*@ngInject*/
function SiloOverview() {
    return {
        restrict: "E",
        scope: true,
        bindToController: {
            ctx: '=',
            telemetryType: '<'
        },
        controller: SiloOverviewController,
        controllerAs: 'vm',
        templateUrl: siloOverviewTemplate
    };
}

/* eslint-disable angular/angularelement */

/*@ngInject*/
function SiloOverviewController($scope, $filter, $translate, types, agTypes, agUtils, siloService, unitService, userService) {

    let vm = this;

    vm.agTypes = agTypes;
    vm.loading = false;

    vm.showData = userService.getAuthority() === 'TENANT_ADMIN' || userService.getAuthority() === 'CUSTOMER_USER';
    vm.siloId = null;
    vm.silo = null;
    vm.connectedSystems = [];

    $scope.$watch('vm.ctx', function() {
        if (vm.ctx && vm.showData) {
            vm.ctx.widgetActions = [vm.helpPageAction];
            vm.ctx.hideTitlePanel = false;

            vm.siloId = null;
            if (vm.ctx.stateController) {
                vm.siloId = vm.ctx.stateController.getStateParams().entityId;
            }
            loadSilo();
            $scope.$watch(function() {
                    return vm.ctx.stateController.getStateParams().entityId;
                },
                function (newSiloId, prevSiloId) {
                    if (newSiloId && !angular.equals(newSiloId, prevSiloId)) {
                        vm.siloId = newSiloId;
                        loadSilo();
                    }
                }
            );

        }
    });

    $scope.$watch(function() { return vm.silo ? (vm.silo.label || vm.silo.name) : null; }, function(title) {
        if (vm.showData && vm.ctx && title) {
            vm.ctx.widgetTitle = $translate.instant('ag.silo.silo-overview') + ': ' + title;
        }
    });

    function loadSilo() {
        vm.silo = null;
        vm.connectedSystems = [];
        if (vm.siloId) {
            vm.loading = true;
            siloService.getSilo(vm.siloId).then(
                function success(silo) {
                    vm.silo = silo;

                    siloService.getSiloConnectedSystems(vm.siloId).then(
                        function success(connectedSystems) {
                            vm.connectedSystems = connectedSystems ?? [];
                        }
                    );

                    vm.loading = false;
                },
                function fail() {
                    vm.loading = false;
                }
            );
        }
    }
}
